'use client';

import { FullListing } from '@th/shared/src/types/FullListing';
import { DEFAULT_IMAGE_RESOLUTION } from '@th/frontend-shared/src/constants/images';
import { useState } from 'react';
import ListingImagesMultipleImageFullScreenModal from './ListingImagesMultipleImageFullScreenModal';
import ListingImageHero from './ListingImageHero';
import ListingCarousel from './ListingCarousel';

type Props = {
  listing: FullListing;
  isBlurred: boolean;
};

export default function ImageHero({ listing, isBlurred }: Props) {
  const [isListingImagesModalOpen, setIsListingImagesModalOpen] =
    useState(false);

  return (
    <div>
      <ListingImagesMultipleImageFullScreenModal
        listing={listing}
        isOpen={isListingImagesModalOpen}
        onClose={() => {
          setIsListingImagesModalOpen(false);
        }}
      />
      <div className="hidden sm:block" id="desktop">
        <ListingImageHero
          listing={listing}
          onImageClick={() => {
            setIsListingImagesModalOpen(true);
          }}
          isBlurred={isBlurred}
        />
      </div>
      <div className="block sm:hidden" id="mobile">
        <ListingCarousel
          listing={listing}
          onClickCallback={() => {
            setIsListingImagesModalOpen(true);
          }}
          imageSize="medium"
          className="w-full"
          isBlurred={isBlurred}
        />
      </div>
    </div>
  );
}
